<div *ngIf="label" [id]="labelId" class="mui-radio-group__label">{{ label }}</div>
<div class="mui-radio-group__container" [class.vertical]="vertical">
    <label *ngFor="let option of options; let i = index"
           class="mui-radio"
           [attr.tabindex]="input.checked || (hasNoSelection() && i === 0 && !isCheckboxDisabled(option)) ? 0 : -1"
           (keydown)="onKeyDown($event, i)"
           [class.checked]="input.checked"
           [class.disabled]="isCheckboxDisabled(option)">
        <input type="radio"
               #input
               tabindex="-1"
               [id]="id + '-option-' + i"
               (change)="onChange(option.value)"
               [name]="name"
               [value]="option.value"
               [checked]="input.checked"
               [attr.checked]="input.checked || null"
               [disabled]="isCheckboxDisabled(option)">
        <span class="mui-radio__cb"></span>
        <span class="mui-radio__label">
            <ng-container [ngTemplateOutlet]="option.template || defaultTemplate"></ng-container>
            <ng-template #defaultTemplate>{{ option.label }}</ng-template>
        </span>
    </label>
</div>


